import React, { useMemo } from 'react';
import {
  CircleBackground,
  CircleProgress,
  CircleSVG,
  StepNumber,
  StepperWrapper,
} from './OnboardingStepsMobile.styles';
import { selectUser } from '../../store/slices/user/slice';
import { useSelector } from 'react-redux';
import { STEP_INDEX } from '../OnboardingSteps/OnboardingSteps';
import { INFLUENCER_REQUEST_STATUS } from '../../utils/constants';

const OnboardingStepsMobile = () => {
  const radius = 10.5;
  const circumference = 2 * Math.PI * radius;

  const user = useSelector(selectUser);

  const activeStep = useMemo(() => {
    return STEP_INDEX[user.status] || 1;
  }, [user]);

  const offset = useMemo(() => {
    return (
      circumference - (((activeStep / STEP_INDEX[INFLUENCER_REQUEST_STATUS.APPROVED]) * 100) / 100) * circumference
    );
  }, [activeStep, circumference]);

  return (
    <StepperWrapper>
      <CircleSVG>
        <CircleBackground r={radius} cx="12" cy="12" />
        <CircleProgress r={radius} cx="12" cy="12" strokeDasharray={circumference} strokeDashoffset={offset} />
      </CircleSVG>
      <StepNumber>{activeStep}</StepNumber>
    </StepperWrapper>
  );
};

export default OnboardingStepsMobile;
